import Phaser from 'phaser';
import { Howler } from 'howler';
import {gsap} from 'gsap';

import SystemUtils from '../../../../../common/utils/system';

import RecBtn from './_recbtn';
import RecFin from './_recfin';
import SetsumeiBtn from './_setsumei';
import Insentive from './_insentive';
import RecError from './_error';


export default class Recording{

    constructor(){
        this.scene = GAME_REF.scene;
        GAME_REF.obj.recording = this;

        this.container = null;
        this.recbtn = null;
        this.recfin = null;
        this.insentive = null;
        this.setsumeibtn = null;

        this.recorder;
        this.audioContext;
        this.audioChunks;
        this.source;
        this.audioBuffer;
        this.stream;

        this.dragon = GAME_REF.obj.dragon;
        this.recError = null;

        this.sound = GAME_REF.obj.sound;

        this.playendTimer = null;
        this._pause = this._pause.bind(this);
        this._resume = this._resume.bind(this);

        this._init();
    }


    render(){
        this.recbtn.render();
        this.container.visible = true;
    }


    reRec(){
        this.setsumeibtn.render();
        this.recbtn.reRec();
        this.container.visible = true;
    }


    start(){
        this.recbtn.start();
        this.setsumeibtn.render();

        this.scene.tweens.add({
            targets: this.att,
            alpha: 1,
            duration: 500,
            delay: 500,
            ease: 'Cubic.easeOut'
        });
    }

    
    _init(){
        this.insentive = new Insentive();
        this.insentive.init();

        this.recError = new RecError();

        this._create();
    }


    _create(){
        this.container = this.scene.add.container(0, 0);
        this.container.visible = false;

        // 録音ボタン
        this.recbtn = new RecBtn(this.container);
        this.recbtn.emitter.on(this.recbtn.EVENT_REC_START, ()=>{
            this.sound.stopAll();
            this.setsumeibtn.hide();
            
            this.sound.playOne('kaisetsu_na8', ()=>{
                this.dragon.fuwa();
                this._recstart();
            });
        });

        this.recbtn.emitter.on(this.recbtn.EVENT_REC_END, ()=>{

            setTimeout(()=>{
                this._recstop();
            }, 500);
        });


        // もう一度説明をきく
        this.setsumeibtn = new SetsumeiBtn(this.container);
        this.setsumeibtn.emitter.on(this.setsumeibtn.EVENT_CLICK, ()=>{
            this.sound.stopAll();
            this.recbtn.reset();
            GAME_REF.obj.question.restart();
        });


        // 再生完了後の画面
        this.recfin = new RecFin();
        this.recfin.emitter.on(this.recfin.EVENT_REC_PLAY, ()=>{
            this._replayAudio();
        });
        this.recfin.emitter.on(this.recfin.EVENT_REC_RETRY, ()=>{
            this.dragon.stopFuwa();
            this.recbtn.reset();
            GAME_REF.obj.question.reRec();
            this._stopAudio();
        });
        this.recfin.emitter.on(this.recfin.EVENT_REC_OK, ()=>{
            this.recbtn.reset();
            this.insentive.render();
            this._stopAudio();
        });
    }


    /**
     * 録音まわりの処理
     */
    async _recstart(){
        // ブラウザサポートのチェック
        if(!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia){
            console.error('getUserMediaはサポートされていません。');
            this.recError.render(1);
            return;
        }

        // マイクの使用許可
        try{
            this.stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            await this._recording();
            this.recbtn.progress();
        }
        catch (error){
            console.log('マイクのアクセスが許可されていませんまたはマイクが無効です。');
            this.recError.render(2);
        }
    }

    async _recording(){
        this.audioChunks = [];
        this.audioContext = new window.AudioContext();
        this.gainNode = this.audioContext.createGain();

        this.recorder = new MediaRecorder(this.stream);
        this.recorder.addEventListener('dataavailable', e => {
            this.audioChunks.push(e.data);
        });
        this.recorder.start();

        this.recbtn.hand.visible = false;
    }

    async _recstop(){
        if(!this.recorder) return;

        try {
            this.recorder.stop();

            // 録音を停止した後、マイクへのアクセスを終了する
            if(this.stream) this.stream.getTracks().forEach(track => {track.stop();});
            
            setTimeout(async ()=>{
                let audioBlob = new Blob(this.audioChunks);
                let audioUrl = URL.createObjectURL(audioBlob);

                const response = await fetch(audioUrl);
                const arrayBuffer = await response.arrayBuffer();
                this.audioBuffer = await this.audioContext.decodeAudioData(arrayBuffer);

                await this._playAudio();
                this.recbtn.playMode();
            }, 500);
        } 
        catch (error){
            console.log('録音の停止中にエラーが発生しました。');
        }
    }


    /**
     * 音声を再生する (初回の再生はこっち)
     */
    async _playAudio(){
        this.source = this.audioContext.createBufferSource();
        this.source.buffer = this.audioBuffer;
        this.gainNode.gain.value = 2;
        this.source.connect(this.gainNode);
        this.gainNode.connect(this.audioContext.destination);

        // 再生終了後の処理
        this.source.addEventListener('ended', async ()=>{

            this.playendTimer = gsap.delayedCall(1.5, ()=>{
                this.playendTimer = null;
                this.recfin.render();
                this.recbtn.hide();
            });

            // オーディオコンテキストを閉じる
            //await this.audioContext.close();
            //this.audioContext = null;
        });

        this.source.start();
    }


    /**
     * 録音した音声を再度再生する
     */
    async _replayAudio(){
        await this._stopAudio();

        this.audioContext = new window.AudioContext();
        this.gainNode = this.audioContext.createGain();

        this.source = this.audioContext.createBufferSource();
        this.source.buffer = this.audioBuffer;
        
        this.gainNode.gain.value = 2;
        this.source.connect(this.gainNode);
        this.gainNode.connect(this.audioContext.destination)

        this.source.addEventListener('ended', async ()=>{
        });

        this.source.start();
    }


    async _stopAudio(){
        if(!this.source) return;

        this.source.stop();
        this.source.disconnect();
        this.source = null;
    }


    _afterRecPlayVolume(){
        if(!SystemUtils.isiOS) return;
        Howler.volume(1);
    }


    _pause(){
        if(this.playendTimer) this.playendTimer.pause();
    }

    _resume(){
        if(this.playendTimer) this.playendTimer.resume();
    }
}